<template>
    <div class="star_div">
        <ul class="star clearFix fl">
            <li class="fl" :class="{gray:n==0,half:n==0.5}" v-for="(n,index) in starCount" :key="index"></li>
        </ul>
        <div class="score_text">{{score_show}}</div>
    </div>

</template>
<script>
export default {
    name:'star',
    props:['score'],
    computed: {
        starCount() {
            var arr = [];
            var score = this.score + '';
            var fir = score.substring(0, 1);
            for (var i = 1; i < 6; i++) {
                if (i <= fir) {
                    arr.push(i)
                } else {
                    arr.push(0);
                }
            }
            if (score.indexOf('.5') != -1) {
                arr.splice(fir, 1, 0.5);
            }
            return arr;
        },
        score_show() {
            var score = parseFloat(this.score);
            return (score * 2).toFixed(0) + '分';
        }
    },
}
</script>

<style lang="stylus">
    .star_div
        overflow:hidden
        margin-top: 0.1rem;
        .star
            float:left
            width:4.5rem
            li
                width:0.7rem
                height:0.7rem
                background:url('../assets/images/star_mostlittle_red.png') no-repeat
                background-size:100% 100%
                margin-right:0.15rem
            .gray
                background:url('../assets/images/star_mostlittle_gray.png') no-repeat
                background-size:100% 100%
            .half
                background:url('../assets/images/star_mostlittle_half.png') no-repeat
                background-size:100% 100%
        .score_text
                display: block
                float: left
                height: .7rem
                font-size: .7rem
                font-weight: bold
                line-height: .8rem
                color: #ff8161
</style>


// WEBPACK FOOTER //
// star.vue?7761f6c1